import { c as _c } from "react/compiler-runtime";
import { aspCond } from '@module/helpers/conditions/condition';
import AdHeartMenuItem from '@pc/components/atoms/menu-item/topbar/AdHeartMenuItem';
import CouponRegistrationMenuItem from '@pc/components/atoms/menu-item/topbar/CouponRegistrationMenuItem';
import EventMenuItem from '@pc/components/atoms/menu-item/topbar/EventMenuItem';
import FaqMenuItem from '@pc/components/atoms/menu-item/topbar/FaqMenuItem';
import NoticeMenuItem from '@pc/components/atoms/menu-item/topbar/NoticeMenuItem';
import { Separator } from '@pc/components/ui/separator';
import LoginModal from './before/LoginRegisterMenuItem';
export function BeforeItem() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-[8px] py-[16px]"><LoginModal /></div>;
    t1 = <Separator className="bg-colorBg23" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-colorBg14 text-colorFg01">{t0}{t1}<div className=" p-2 "><EventMenuItem>{"\uC774\uBCA4\uD2B8"}</EventMenuItem>{!aspCond.if("new-asp") && <><NoticeMenuItem>{"\uACF5\uC9C0\uC0AC\uD56D"}</NoticeMenuItem><AdHeartMenuItem>무료하트</AdHeartMenuItem><CouponRegistrationMenuItem>{"\uCFE0\uD3F0\uB4F1\uB85D"}</CouponRegistrationMenuItem><FaqMenuItem>{"\uC790\uC8FC\uD558\uB294 \uC9C8\uBB38"}</FaqMenuItem></>}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}